import React, {useState} from "react";
import AppSettingController from "../../../Main/controller/AppSettingController";
import MarketSettingLocalStorage from "../../../Main/interface/MarketSettingLocalStorage";
import marketSettingLocalStorage from "../../../Main/interface/MarketSettingLocalStorage";
import {useTranslation} from "react-i18next";

export default function SelectMode() {
    const {t} = useTranslation();
    const [state, setState] = useState<MarketSettingLocalStorage['marketMode']>("pos")
    const setting = AppSettingController.getSetting() as marketSettingLocalStorage

    const values = [
        {value: "pos", label: t("setting.pos")},
        {value: "cash", label: t("setting.cash")},
        {value: "pos-or-cash", label: t("setting.posOrCash")},
        {value: "no-payment", label: t("setting.noPayment")},
        {value: "price-without-purchase", label: t("setting.priceWithoutPurchase")},
        {value: "view-only", label: t("setting.viewOnly")},
    ]

    return (
        <section>
            <p>{t("setting.orderTakerMode")}</p>
            <div className={'form-receipt'}>
                <form
                    onSubmit={e => AppSettingController.setMarketMode(state as MarketSettingLocalStorage['marketMode'], e)}>
                    <select onChange={e => setState(e.target.value as MarketSettingLocalStorage['marketMode'])}
                            defaultValue={setting.marketMode}>
                        {values.map(value => <option value={value.value} key={value.value}>{value.label}</option>)}
                    </select>
                    <button type="submit">{t("submit")}</button>
                </form>
            </div>
        </section>
    )
}